import { dcb } from '@dcb/jssdk'
import { getPageUrl } from '@/router'

export class GroupBuyingUtils {
  /** 分享 */
  static share(payload: {
    /** 商品名称 */
    goodsName: string
    /** 商品封面图 */
    goodsCover: string
    /** 商品价格 */
    goodsPrice: number
    /** 团单ID */
    groupOrderId: string
    /** 一阶团剩余名额 */
    remainingCount: number
  }) {
    if (payload.remainingCount) {
      // 调起微信分享
      // 标题：【仅剩${props.data.groupData.nextLevelCount}个名额】我${props.data.commodityInfo.groupPrice}元拼了${props.data.commodityInfo.commodityName}
      // 简介：我买了“${props.data.commodityInfo.commodityName}”
      dcb.share({
        // @ts-ignore
        guide: '点击右上角邀请好友吧~',
        title: `【仅剩${payload.remainingCount}个名额】我${payload.goodsPrice}元拼了${payload.goodsName}`,
        desc: `我买了“${payload.goodsName}”`,
        url: getPageUrl('GroupBuyingInvite', {
          id: payload.groupOrderId,
        }),
        cover: payload.goodsCover,
      })
    } else {
      // 调起微信分享
      // 标题：【一起来拼吧】我${props.data.commodityInfo.groupPrice}元拼了${props.data.commodityInfo.commodityName}
      // 简介：我买了“${props.data.commodityInfo.commodityName}”
      dcb.share({
        // @ts-ignore
        guide: '点击右上角邀请好友吧~',
        title: `【一起来拼吧】我${payload.goodsPrice}元拼了${payload.goodsName}`,
        desc: `我买了“${payload.goodsName}”`,
        url: getPageUrl('GroupBuyingInvite', {
          id: payload.groupOrderId,
        }),
        cover: payload.goodsCover,
      })
    }
  }
}
